'use client';

import React, { useState } from 'react';
import {
    ComposableMap,
    Geographies,
    Geography,
    Marker,
    ZoomableGroup
} from "react-simple-maps";

interface Location {
    name: string;
    coordinates: [number, number];
    state: string;
}

interface MapProps {
    locations: Location[];
}

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const Map: React.FC<MapProps> = ({ locations }) => {
    const [hoveredLocation, setHoveredLocation] = useState<{ name: string; x: number; y: number } | null>(null);

    return (
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
            <ComposableMap projection="geoAlbersUsa">
                <Geographies geography={geoUrl}>
                    {({ geographies }) =>
                        geographies.map((geo) => (
                            <Geography
                                key={geo.rsmKey}
                                geography={geo}
                                fill="#EAEAEC"
                                stroke="#D6D6DA"
                                style={{
                                    default: {
                                        outline: "none",
                                    },
                                    hover: {
                                        outline: "none",
                                    },
                                    pressed: {
                                        outline: "none",
                                    },
                                }}
                            />
                        ))
                    }
                </Geographies>
                {locations.map((location, index) => (
                    <Marker
                        key={index}
                        coordinates={[location.coordinates[1], location.coordinates[0]]}
                        onMouseEnter={(event) => {
                            const rect = event.currentTarget.getBoundingClientRect();
                            setHoveredLocation({
                                name: location.name,
                                x: rect.left + rect.width / 2,
                                y: rect.top - 10
                            });
                        }}
                        onMouseLeave={() => setHoveredLocation(null)}
                    >
                        <image
                            href="/logo.png"
                            width={20}
                            height={20}
                            x={-10}
                            y={-10}
                        />
                    </Marker>
                ))}
            </ComposableMap>
            {hoveredLocation && (
                <div
                    style={{
                        position: 'fixed',
                        left: hoveredLocation.x,
                        top: hoveredLocation.y,
                        transform: 'translate(-50%, -100%)',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        color: 'white',
                        padding: '6px 12px',
                        borderRadius: '4px',
                        fontSize: '14px',
                        pointerEvents: 'none',
                        zIndex: 1000,
                        whiteSpace: 'nowrap',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                >
                    {hoveredLocation.name}
                </div>
            )}
        </div>
    );
};

export default Map; 